import _styled from "@emotion/styled-base"; // external dependencies

import React from 'react';
// components
import { ChevronBlock } from '@jelly/components'; // styled components

var IconWrap = _styled("div", {
  target: "e1a4tdtd0",
  label: "IconWrap"
})("align-items:center;background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.orange;
}, ";display:flex;cursor:pointer;height:41px;justify-content:center;left:", function (_ref2) {
  var direction = _ref2.direction;
  return direction === 'left' && '0';
}, ";position:absolute;right:", function (_ref3) {
  var direction = _ref3.direction;
  return direction === 'right' && '0';
}, ";transform:", function (_ref4) {
  var direction = _ref4.direction;
  return direction === 'left' && 'scaleY(-1) rotate(180deg)';
}, ";width:30px;z-index:1;", function (_ref5) {
  var theme = _ref5.theme;
  return theme.MQ.M;
}, "{", function (_ref6) {
  var displayArrow = _ref6.displayArrow;
  return !displayArrow && "display: none;";
}, "}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9DYXRlZ29yeS9zZW8vVGFicy9UYWJBcnJvdy5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBUzJCIiwiZmlsZSI6Ii4uLy4uLy4uLy4uL3NyYy9DYXRlZ29yeS9zZW8vVGFicy9UYWJBcnJvdy5qc3giLCJzb3VyY2VzQ29udGVudCI6WyIvLyBleHRlcm5hbCBkZXBlbmRlbmNpZXNcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCB7IGJvb2wsIGZ1bmMsIHN0cmluZyB9IGZyb20gJ3Byb3AtdHlwZXMnXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcblxuLy8gY29tcG9uZW50c1xuaW1wb3J0IHsgQ2hldnJvbkJsb2NrIH0gZnJvbSAnQGplbGx5L2NvbXBvbmVudHMnXG5cbi8vIHN0eWxlZCBjb21wb25lbnRzXG5jb25zdCBJY29uV3JhcCA9IHN0eWxlZC5kaXZgXG5cdGFsaWduLWl0ZW1zOiBjZW50ZXI7XG5cdGJhY2tncm91bmQtY29sb3I6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuY29sb3JzLm9yYW5nZX07XG5cdGRpc3BsYXk6IGZsZXg7XG5cdGN1cnNvcjogcG9pbnRlcjtcblx0aGVpZ2h0OiA0MXB4O1xuXHRqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcblx0bGVmdDogJHsoeyBkaXJlY3Rpb24gfSkgPT4gZGlyZWN0aW9uID09PSAnbGVmdCcgJiYgJzAnfTtcblx0cG9zaXRpb246IGFic29sdXRlO1xuXHRyaWdodDogJHsoeyBkaXJlY3Rpb24gfSkgPT4gZGlyZWN0aW9uID09PSAncmlnaHQnICYmICcwJ307XG5cdHRyYW5zZm9ybTogJHsoeyBkaXJlY3Rpb24gfSkgPT4gZGlyZWN0aW9uID09PSAnbGVmdCcgJiYgJ3NjYWxlWSgtMSkgcm90YXRlKDE4MGRlZyknfTtcblx0d2lkdGg6IDMwcHg7XG5cdHotaW5kZXg6IDE7XG5cblx0JHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5NUS5NfSB7XG5cdFx0JHsoeyBkaXNwbGF5QXJyb3cgfSkgPT4gIWRpc3BsYXlBcnJvdyAmJiBgZGlzcGxheTogbm9uZTtgfVxuXHR9XG5gXG5cblRhYkFycm93LnByb3BUeXBlcyA9IHtcblx0ZGlyZWN0aW9uOiBzdHJpbmcsXG5cdGRpc3BsYXlBcnJvdzogYm9vbCxcblx0b25DbGljazogZnVuYy5pc1JlcXVpcmVkLFxufVxuXG5leHBvcnQgZnVuY3Rpb24gVGFiQXJyb3coeyBkaXJlY3Rpb24sIGRpc3BsYXlBcnJvdywgb25DbGljayB9KSB7XG5cdHJldHVybiAoXG5cdFx0PEljb25XcmFwIGRpcmVjdGlvbj17ZGlyZWN0aW9ufSBvbkNsaWNrPXtvbkNsaWNrfSBkaXNwbGF5QXJyb3c9e2Rpc3BsYXlBcnJvd30+XG5cdFx0XHQ8Q2hldnJvbkJsb2NrIGhlaWdodD1cIjMwcHhcIiB3aWR0aD1cIjMwcHhcIiBmaWxsPVwiI2ZmZlwiIC8+XG5cdFx0PC9JY29uV3JhcD5cblx0KVxufVxuIl19 */"));

export function TabArrow(_ref7) {
  var direction = _ref7.direction,
      displayArrow = _ref7.displayArrow,
      onClick = _ref7.onClick;
  return /*#__PURE__*/React.createElement(IconWrap, {
    direction: direction,
    onClick: onClick,
    displayArrow: displayArrow
  }, /*#__PURE__*/React.createElement(ChevronBlock, {
    height: "30px",
    width: "30px",
    fill: "#fff"
  }));
}